import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Paper } from '@mui/material'
import { Container, Col, Row } from 'react-bootstrap'
import { RiPagesLine } from "react-icons/ri"
import { GiProcessor } from "react-icons/gi"
import { useOutletContext } from 'react-router-dom'

import AIConfigModal from './components/AIConfigModal'

import useFetchData from 'Shared/Hooks/useFetchData'
import useLoop from 'Shared/Hooks/useLoop'
import DataTable from 'Shared/Components/DataTable'
import { apiUrl } from 'Shared/utils'
import PopupModal from 'Shared/Components/PopupModal'

const CameraList = () => {
  const { role, setPageLoading } = useOutletContext()

  const { t } = useTranslation()
  const { send } = useFetchData()
  
  const [cameras, setCameras] = useState([])
  const [AIModalOpen, setAIModalOpen] = useState()

  const fetchCameras = async () => {
    const body = await send({
      method: "GET",
      url: `${apiUrl}/camera/list`,
      returnType: "json"
    })

    setCameras(
      body.map((i) => ({
        "name": i["name"],
        "camera_id": i["camera_id"],
        "model": i["model"],
        "sn": i["sn"],
        "ai_enabled": i["ai_enabled"],
        "url": i["url"],
        "body_camera": i["body_camera"],
        "online": (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
            <span style={{ height: "15px", width: "15px", backgroundColor: i["online"] ? "green" : "red", borderRadius: "50%" }}></span>
          </div>
        )
      }))
    )
  }

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      await fetchCameras()

      setPageLoading(false)
    }

    init()
  }, [])

  useLoop(fetchCameras, 10000)

  return (<>
    <Container fluid className="mainContainer" style={{ backgroundColor: "white", borderRadius: "15px" }}>
      <Row style={{ height: "100%" }}>
        <Col xs={12} style={{ height: "100%", overflow: "auto", padding: "10px" }}>
          <Paper elevation={0} sx={{ height: "100%", display: "flex", flexFlow: "column" }}>
            <DataTable
              data={cameras} count={null}
              columns={{
                "online": { "label": t("general_online"), "sorting": false, "nowrap": true },
                "name": { "label": t("general_deviceName"), "sorting": false, "nowrap": true },
                "model": { "label": t("cameras_model"), "sorting": false, "nowrap": true },
                "sn": { "label": t("cameras_serialNumber"), "sorting": false, "nowrap": true },
              }}
              renderActions={(row) => { return [
                (["pm", "admin"].includes(role) && !row["body_camera"]) && {icon: <RiPagesLine size={20}/>, text: t("cameras_cameraPage"), onClick: function(row) { window.open(row["url"]) }},
                (["pm", "admin"].includes(role) && row["ai_enabled"] === true) && {icon: <GiProcessor size={20}/>, text: t("cameras_aiConfig"), onClick: function(row) { setAIModalOpen(row["camera_id"]) }},
              ]}}
            />
          </Paper>
        </Col>
      </Row>
    </Container>

    <PopupModal isOpen={AIModalOpen != null} close toggle={() => setAIModalOpen()} width="80%" height="80%">
      <AIConfigModal camera_id={AIModalOpen}/>
    </PopupModal>
  </>)
}

export default CameraList
